export const NON_LINEAR_SLIDER_MIN = 1;
export const NON_LINEAR_SLIDER_MAX = 999;
const NON_LINEAR_SLIDER_RANGE = NON_LINEAR_SLIDER_MAX - NON_LINEAR_SLIDER_MIN;

export const convertValueToNonLinearSliderPosition = (val: number, min: number, max: number): number => {
  const range = max - min;
  const normalized = (val - min) / range;
  const scaledVal = normalized * NON_LINEAR_SLIDER_MAX + NON_LINEAR_SLIDER_MIN;
  let percentageForSlider;

  if (scaledVal <= 144) {
    percentageForSlider = 0.5594405594 * scaledVal - 0.5594405594;
    return (percentageForSlider * NON_LINEAR_SLIDER_RANGE) / 100;
  }

  if (scaledVal <= 239) {
    percentageForSlider = 0.105 * scaledVal + 64.88;
    return (percentageForSlider * NON_LINEAR_SLIDER_RANGE) / 100;
  }

  percentageForSlider = 0.013 * scaledVal + 87.013;
  return (percentageForSlider * NON_LINEAR_SLIDER_RANGE) / 100;
};

export const convertNonLinearSliderPositionToValue = (val: number, min: number, max: number): number => {
  const valueInPercentage = (val * 100) / NON_LINEAR_SLIDER_RANGE;

  let scaledVal: number;
  if (valueInPercentage <= 80) {
    scaledVal = (valueInPercentage + 0.5594405594) / 0.5594405594;
  } else if (valueInPercentage <= 90) {
    scaledVal = (valueInPercentage - 64.88) / 0.105;
  } else if (valueInPercentage > 100) {
    return max;
  } else {
    scaledVal = (valueInPercentage - 87.013) / 0.013;
  }

  const normalized = (scaledVal - 1) / NON_LINEAR_SLIDER_MAX;
  return normalized * (max - min) + min;
};
